import { DailyOvertimeDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/DailyOvertimeDashboard/store/dailyOvertimeDashboard.store.types';
import {
  OVERTIME_BY_TEAM_MEMBER_TYPE_STUB,
  OVERTIME_HOURS_BY_POSITION_STUB,
  OVERTIME_INDIVIDUALS_STUB,
  OVERTIME_TREND_STUB,
} from 'pages/ReportsPage/components/AnalyticsDashboards/dataLockedStubData';

export const DAILY_OVERTIME_DATA_LOCKED_STUB: Partial<DailyOvertimeDashboardStore> = {
  totalOtHours: 1318.25,
  totalOtHoursChangePrct: 8,
  otRate: 1.52,
  otRateChangePrct: 0.3,
  priorPeriodRange: ['2026-05-04', '2026-05-10'],
  overtimeByPosition: OVERTIME_HOURS_BY_POSITION_STUB,
  overtimeByTeamMemberType: OVERTIME_BY_TEAM_MEMBER_TYPE_STUB,
  overtimeTrend: OVERTIME_TREND_STUB,
  overtimeIndividuals: OVERTIME_INDIVIDUALS_STUB,
  individualsPage: 1,
  individualsTotalPages: 1,
};
